/**
 * Diverge AI Chatbot – Event Binding
 *
 * Binds all native theme trigger elements to the DivergeChatbot API.
 * Uses event delegation for dynamically injected content (predictive search).
 */
(function () {
  'use strict';

  // ── Sparkle SVG icon (reusable) ──
  var SPARKLE_SVG = '<svg width="24" height="24" viewBox="0 0 41 38" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-13.5333,-10.9786)"><path d="M21,14L47,14C50.84,14 54,17.16 54,21L54,37C54,40.84 50.84,44 47,44L25,44L18.548,48.692L18,44C15.328,42.749 13.722,39.937 14,37L14,21C14,17.16 17.16,14 21,14ZM36,19C37.53,24.94 39.06,26.47 45,28C39.06,29.53 37.53,31.06 36,37C34.47,31.06 32.94,29.53 27,28C32.94,26.47 34.47,24.94 36,19ZM25,19.4C25.612,21.776 26.224,22.388 28.6,23C26.224,23.612 25.612,24.224 25,26.6C24.388,24.224 23.776,23.612 21.4,23C23.776,22.388 24.388,21.776 25,19.4Z"/></g></svg>';

  /**
   * Gets the current search query from the active search input.
   * @returns {string}
   */
  function getSearchQuery() {
    var input = document.querySelector('.js-search-input');
    return input ? input.value.trim() : '';
  }

  /**
   * Handles click on the predictive search AI trigger.
   * @param {Event} e
   */
  function handlePredictiveTrigger(e) {
    var btn = e.target.closest('.js-ai-chat-predictive');
    if (!btn || !window.DivergeChatbot) return;

    e.preventDefault();
    e.stopPropagation();

    var query = btn.dataset.query || getSearchQuery();
    if (query) {
      window.DivergeChatbot.openWithMessage(
        'Jeg søger efter "' + query + '" og har brug for rådgivning'
      );
    } else {
      window.DivergeChatbot.open();
    }
  }

  /**
   * Handles click on the collection page AI banner CTA.
   * @param {Event} e
   */
  function handleCollectionTrigger(e) {
    var btn = e.target.closest('.js-ai-chat-collection');
    if (!btn || !window.DivergeChatbot) return;

    e.preventDefault();
    var title = btn.dataset.collectionTitle || '';
    var message = title
      ? 'Jeg kigger på ' + title + ' og har brug for rådgivning'
      : '';

    if (message) {
      window.DivergeChatbot.openWithMessage(message);
    } else {
      window.DivergeChatbot.open();
    }
  }

  /**
   * Closes any open drawer/overlay, then opens the chatbot (optionally with
   * a pre-filled message) after a short delay for the close animation.
   * @param {string} [prompt]
   */
  function openChatWithPrompt(prompt) {
    if (!window.DivergeChatbot) return;

    // Close any open drawer/overlay so the chat window isn't hidden behind it
    var closeBtn = document.querySelector('side-drawer[open] .js-close-drawer');
    if (closeBtn) {
      closeBtn.click();
    }
    // Also dismiss the overlay backdrop
    var overlay = document.querySelector('.overlay.is-visible');
    if (overlay) {
      overlay.click();
    }

    // Small delay to let drawer close animation start before opening chat
    setTimeout(function () {
      if (prompt) {
        window.DivergeChatbot.openWithMessage(prompt);
      } else {
        window.DivergeChatbot.open();
      }
    }, 150);
  }

  /**
   * Handles click on generic open triggers (FAB, service page button, help).
   * Supports optional data-prompt attribute for context (e.g. customer service).
   * @param {Event} e
   */
  function handleOpenTrigger(e) {
    var btn = e.target.closest('.js-ai-chat-open');
    if (!btn || !window.DivergeChatbot) return;

    e.preventDefault();
    openChatWithPrompt(btn.getAttribute('data-prompt'));
  }

  /**
   * Handles submit of an inline "ask a question" form (e.g. PDP product
   * prompt, customer service hero). When a question is typed, it's sent
   * prefixed with the form's data-prompt-prefix (if any, e.g. "Jeg søger
   * efter: "). An empty submit falls back to data-fallback-prompt.
   * @param {Event} e
   */
  function handlePromptFormSubmit(e) {
    var form = e.target.closest('.js-ai-chat-prompt-form');
    if (!form || !window.DivergeChatbot) return;

    e.preventDefault();

    var input = form.querySelector('.js-ai-chat-prompt-input');
    var question = input ? input.value.trim() : '';
    var message = question
      ? (form.getAttribute('data-prompt-prefix') || '') + question
      : (form.getAttribute('data-fallback-prompt') || '');
    openChatWithPrompt(message);

    if (input) {
      input.value = '';
    }
  }

  // ── Bind static elements on DOMContentLoaded ──
  function init() {
    // 1. Collection banner CTA (event delegation on document for lazy-loaded content)
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-ai-chat-collection')) {
        handleCollectionTrigger(e);
      }
    });

    // 2. Generic open triggers (FAB, service page)
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-ai-chat-open')) {
        handleOpenTrigger(e);
      }
    });

    // 3. Predictive search AI trigger (event delegation – content is dynamically injected)
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-ai-chat-predictive')) {
        handlePredictiveTrigger(e);
      }
    });

    // 3b. Inline "ask a question" forms (e.g. PDP product prompt)
    document.addEventListener('submit', function (e) {
      if (e.target.closest('.js-ai-chat-prompt-form')) {
        handlePromptFormSubmit(e);
      }
    });

    // 4. Customer service page: redirect old Zendesk buttons to Diverge
    var zendeskBtn = document.getElementById('open-zendesk');
    if (zendeskBtn && window.DivergeChatbot) {
      zendeskBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.DivergeChatbot.open();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
